import { Property } from "./interfaces";

export const codMunicipioResidencia: Property = {
  title: "Código de Municipio de Residencia",
  type: "string",
};
